'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Navigation = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _NavWrapper = require('components/Header/NavWrapper');

var _UnsubscribedUserNav = require('./Navs/UnsubscribedUserNav');

var _ActiveUserNav = require('./Navs/ActiveUserNav');

var _LoggedInUserLinks = require('./NavItems/LoggedInUserLinks');

var _LiveProductLinks = require('./NavItems/LiveProductLinks');

var _GoProductLinks = require('./NavItems/GoProductLinks');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Navigation = function Navigation(_ref) {
  var canViewUnifiedSearch = _ref.canViewUnifiedSearch,
      isMobile = _ref.isMobile,
      isLoggedIn = _ref.isLoggedIn,
      isUnpaidUser = _ref.isUnpaidUser,
      isUnsubscribedUser = _ref.isUnsubscribedUser,
      isActiveUser = _ref.isActiveUser,
      onClick = _ref.onClick,
      isLivePage = _ref.isLivePage,
      isGoPage = _ref.isGoPage,
      user = _ref.user,
      otherProps = (0, _objectWithoutProperties3.default)(_ref, ['canViewUnifiedSearch', 'isMobile', 'isLoggedIn', 'isUnpaidUser', 'isUnsubscribedUser', 'isActiveUser', 'onClick', 'isLivePage', 'isGoPage', 'user']);

  var shouldShowUnsubscribedNav = !isLoggedIn || isUnsubscribedUser;
  var shouldShowActiveNav = isActiveUser || isUnpaidUser;
  var loggedInOnMobile = isLoggedIn && isMobile;

  var shouldShowNav = !!(shouldShowUnsubscribedNav || shouldShowActiveNav || loggedInOnMobile);

  return shouldShowNav && _react2.default.createElement(
    _NavWrapper.NavWrapper,
    { isMobile: isMobile },
    _react2.default.createElement(
      'ul',
      { onClick: onClick },
      isLivePage && _react2.default.createElement(_LiveProductLinks.LiveProductLinks, null),
      isGoPage && _react2.default.createElement(_GoProductLinks.GoProductLinks, null),
      shouldShowUnsubscribedNav && _react2.default.createElement(_UnsubscribedUserNav.UnsubscribedUserNav, (0, _extends3.default)({}, otherProps, {
        isLoggedIn: isLoggedIn,
        isLivePage: isLivePage,
        isGoPage: isGoPage
      })),
      shouldShowActiveNav && _react2.default.createElement(_ActiveUserNav.ActiveUserNav, {
        user: user,
        isLivePage: isLivePage,
        isGoPage: isGoPage
      }),
      isLoggedIn && isMobile && _react2.default.createElement(_LoggedInUserLinks.LoggedInUserLinks, { canViewUnifiedSearch: canViewUnifiedSearch })
    )
  );
};

exports.Navigation = Navigation;
Navigation.propTypes = {
  canViewUnifiedSearch: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  isActiveUser: _propTypes2.default.bool,
  isUnpaidUser: _propTypes2.default.bool,
  isUnsubscribedUser: _propTypes2.default.bool,
  isLoggedIn: _propTypes2.default.bool,
  isLivePage: _propTypes2.default.bool,
  isGoPage: _propTypes2.default.bool
};